(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react'; // import { BrowserRouter } from 'react-router-dom';

import { renderRoutes } from 'react-router-config'; // import loadable from '@loadable/component';
// import serverRoutes from './serverRoutes';
// import PrivateRoute from './PrivateRoute';

import Routes from './serverRoutes';
import Layout from '../components/Layout'; // import { loadReCaptcha } from 'react-recaptcha-v3';
// const Layout = loadable(() => import('../components/Layout'));
// const AdminLayout = loadable(() => import('../components/admin/AdminLayout'));
// import utilities from '../utils/utilities';
// import ShippingDetails from '../containers/shippings/ShippingDetails';
// import Annular from '../containers/shippings/Annular';
// // import Search from '../containers/shippings/Search';
// import Manifiest from '../containers/shippings/Manifiest';
// import RangePrint from '../containers/shippings/RangePrint';

const locationUrl = window.location.pathname;

const App = ({
  isLogged
}) => {
  // const routes = serverRoutes(isLogged);
  // const adminRoutes = routes.filter((item) => item.layout === 'admin');
  // const publicRoutes = routes.filter((item) => !item.layout);
  // const noLayoutRoutes = routes.filter((item) => item.layout === 'none');
  // const adminRoutesPaths = adminRoutes.map((item) => item.path);
  // const publicRoutesPaths = publicRoutes.map((item) => item.path);
  // const noLayoutRoutesPaths = noLayoutRoutes.map((item) => item.path);
  // console.log('adminRoutesPaths', adminRoutesPaths);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    isLogged: isLogged,
    location: locationUrl
  }, renderRoutes(Routes(isLogged, false))));
};

const _default = App;
export default _default; // export default class App extends Component {
//   componentDidMount() {
//     loadReCaptcha(utilities.recaptcha.PUBLIC_KEY, (res) => console.log('loadReCaptcha', res));
//   }
//   render() {
//     const { isLogged } = this.props;
//     return (
//       <BrowserRouter>
//         <Layout isLogged={isLogged} location={locationUrl}>
//           {renderRoutes(Routes(isLogged))}
//         </Layout>
//       </BrowserRouter>
//     );
//   }
// }

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(locationUrl, "locationUrl", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/App.js");
  reactHotLoader.register(App, "App", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/App.js");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/routes/App.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();